import { DASHBOARDELEMIDS } from '../interfaces';
import { promptAddChart } from './chartTools';
import { promptElementLayoutHints } from './generalTools';
import { promptAddHorizontalLayout, promptAddVerticalLayout } from './horizontalLayoutTools';
import { promptAddSection, promptSectionSettings } from './sectionTools';
import { promptAddStaticText, promptStaticTextSettings } from './staticTextTools';
import { promptAddTabber, promptTabberSettings } from './tabberTools';

export enum EDITBOX_LOCATION {
  HOR_BOTTOM = 'horizontal-bottom',
  VERT_RIGHT = 'vertical-right',
  RIGHT_BOX = 'right-box',
}

enum CHILDREN_LAYOUT {
  HOR = 'horizontal',
  VERT = 'vertical',
  STACKED = 'stacked',
}

export interface TpElemTypeDef {
  id: DASHBOARDELEMIDS;
  name: string;
  compatibleChildren: DASHBOARDELEMIDS[];
  promptAdd: any;
  promptConfigure?: any;
  editBoxType: EDITBOX_LOCATION;
  addBoxType?: EDITBOX_LOCATION;
  childrenLayout?: CHILDREN_LAYOUT;
}

export const elemTypes: TpElemTypeDef[] = [
  {
    id: DASHBOARDELEMIDS.Widget,
    name: 'Widget',
    compatibleChildren: [],
    promptAdd: promptAddChart,
    promptConfigure: promptElementLayoutHints,
    editBoxType: EDITBOX_LOCATION.RIGHT_BOX,
  },

  {
    id: DASHBOARDELEMIDS.StaticText,
    name: 'Static text',
    compatibleChildren: [],
    promptAdd: promptAddStaticText,
    promptConfigure: promptStaticTextSettings,
    editBoxType: EDITBOX_LOCATION.RIGHT_BOX,
  },

  {
    id: DASHBOARDELEMIDS.HorizontalLayout,
    name: 'Horizontal layout',
    compatibleChildren: [
      DASHBOARDELEMIDS.VerticalLayout,
      DASHBOARDELEMIDS.Widget,
      DASHBOARDELEMIDS.StaticText,
      DASHBOARDELEMIDS.Tabber,
    ],
    promptAdd: promptAddHorizontalLayout,
    editBoxType: EDITBOX_LOCATION.VERT_RIGHT,
    childrenLayout: CHILDREN_LAYOUT.HOR,
  },

  {
    id: DASHBOARDELEMIDS.VerticalLayout,
    name: 'Vertical layout',
    compatibleChildren: [DASHBOARDELEMIDS.Widget, DASHBOARDELEMIDS.StaticText, DASHBOARDELEMIDS.Tabber],
    promptAdd: promptAddVerticalLayout,
    promptConfigure: promptElementLayoutHints,
    editBoxType: EDITBOX_LOCATION.VERT_RIGHT,
    childrenLayout: CHILDREN_LAYOUT.VERT,
  },

  {
    id: DASHBOARDELEMIDS.Tabber,
    name: 'Tabber',
    compatibleChildren: [
      DASHBOARDELEMIDS.Widget,
      DASHBOARDELEMIDS.HorizontalLayout,
      DASHBOARDELEMIDS.StaticText,
      DASHBOARDELEMIDS.Section,
      DASHBOARDELEMIDS.Tabber,
    ],
    promptAdd: promptAddTabber,
    promptConfigure: promptTabberSettings,
    editBoxType: EDITBOX_LOCATION.RIGHT_BOX,
    childrenLayout: CHILDREN_LAYOUT.STACKED,
  },

  {
    id: DASHBOARDELEMIDS.Section,
    name: 'Section',
    compatibleChildren: [
      DASHBOARDELEMIDS.HorizontalLayout,
      DASHBOARDELEMIDS.StaticText,
      DASHBOARDELEMIDS.Section,
      DASHBOARDELEMIDS.Tabber,
    ],
    promptAdd: promptAddSection,
    promptConfigure: promptSectionSettings,
    editBoxType: EDITBOX_LOCATION.RIGHT_BOX,
    addBoxType: EDITBOX_LOCATION.HOR_BOTTOM,
    childrenLayout: CHILDREN_LAYOUT.VERT,
  },

  {
    id: DASHBOARDELEMIDS.Dashboard,
    name: 'Dashboard',
    compatibleChildren: [
      DASHBOARDELEMIDS.HorizontalLayout,
      DASHBOARDELEMIDS.StaticText,
      DASHBOARDELEMIDS.Section,
      DASHBOARDELEMIDS.Tabber,
    ],
    promptAdd: null,
    promptConfigure: promptSectionSettings,
    editBoxType: EDITBOX_LOCATION.VERT_RIGHT,
    addBoxType: EDITBOX_LOCATION.HOR_BOTTOM,
    childrenLayout: CHILDREN_LAYOUT.VERT,
  },
];

export const elemTypeMap: { [id: string]: TpElemTypeDef } = {};
for (const elemType of elemTypes) {
  elemTypeMap[elemType.id] = elemType;
}
